"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = connectEAState;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _react = require("react");

var _modes = require("../constants/modes");

var _storage = _interopRequireWildcard(require("../storage/storage"));

var _getEventTrackingConfig = _interopRequireDefault(require("../config/getEventTrackingConfig"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/*
 * `useEADebugPanel` is now state-source-agnostic, meaning we can store state ourselves (parent mode),
 * or grab it from localStorage (popup mode)
*/


var STORAGE_KEY = 'ea-debug-trackrecords';
var PREVIOUS_RECORDS_KEY = 'previous-track-records';
var SESSION_CONFIG_KEY = 'config-session';

function getConfig(_x) {
  return _getConfig.apply(this, arguments);
}

function _getConfig() {
  _getConfig = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(useLocalConfig) {
    var config, storage;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            storage = (0, _storage["default"])(_storage.storageTypes.SESSION);

            if (!storage.getItem(SESSION_CONFIG_KEY)) {
              _context.next = 4;
              break;
            }

            config = JSON.parse(storage.getItem(SESSION_CONFIG_KEY));
            return _context.abrupt("return", {
              setConfigSession: false,
              config: config
            });

          case 4:
            _context.next = 6;
            return (0, _getEventTrackingConfig["default"])(useLocalConfig);

          case 6:
            config = _context.sent;
            return _context.abrupt("return", {
              setConfigSession: true,
              config: config
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getConfig.apply(this, arguments);
}

function connectEAState() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _modes.MODES.PARENT;
  var useLocalConfig = arguments.length > 1 ? arguments[1] : undefined;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      trackRecords = _useState2[0],
      setTrackRecords = _useState2[1]; // If we're "parent", listen to this frame's window.EkoAnalytics instance


  (0, _react.useEffect)(function () {
    // Conditional needs to go inside the useEffect hook because react breaks if hooks are called conditionally
    if (mode !== _modes.MODES.PARENT) {
      return function () {}; // Early return and also "cleanup" function should do nothing
    }

    getConfig(useLocalConfig).then(function (_ref) {
      var setConfigSession = _ref.setConfigSession,
          config = _ref.config;
      var storage = (0, _storage["default"])(_storage.storageTypes.SESSION);

      if (setConfigSession) {
        storage.setItem(SESSION_CONFIG_KEY, JSON.stringify(config));
      }

      var eventFilter = config.eventFilter;
      var blacklisted = {};
      (eventFilter && eventFilter.blacklisted || []).forEach(function (event) {
        blacklisted[event] = true;
      }); // Check for previous events in this session, and push them if they exist

      if (!Object.keys(trackRecords).length && storage.getItem(PREVIOUS_RECORDS_KEY)) {
        setTrackRecords(JSON.parse(storage.getItem(PREVIOUS_RECORDS_KEY)));
      }

      var onTrackEvent = function onTrackEvent(newTrackRecord) {
        setTrackRecords(function (previousTrackRecords) {
          if (newTrackRecord.eventName in blacklisted) {
            return (0, _toConsumableArray2["default"])(previousTrackRecords);
          }

          storage.setItem(PREVIOUS_RECORDS_KEY, JSON.stringify([newTrackRecord].concat((0, _toConsumableArray2["default"])(previousTrackRecords))));
          return [newTrackRecord].concat((0, _toConsumableArray2["default"])(previousTrackRecords));
        });
      };

      if (typeof window.EkoAnalytics === 'function') {
        window.EkoAnalytics('on', 'track', onTrackEvent);
      } // Return a "clean up" fuinction that removes the event listener


      return function () {
        if (typeof window.EkoAnalytics === 'function') {
          window.EkoAnalytics('off', 'track', onTrackEvent);
        }
      };
    });
  }, [mode]); // If we're "parent", attempt to push all state changes to localStorage

  (0, _react.useEffect)(function () {
    if (mode === _modes.MODES.PARENT) {
      var storage = (0, _storage["default"])(_storage.storageTypes.LOCAL);
      storage.setItem(STORAGE_KEY, JSON.stringify(trackRecords));
    }
  }, [trackRecords, mode]); // If we're "popout", listen for localstorage events

  (0, _react.useEffect)(function () {
    if (mode !== _modes.MODES.POPOUT) {
      return function () {};
    }

    getConfig(useLocalConfig).then(function (config) {
      var eventFilter = config.eventFilter;
      var blacklisted = {};
      (eventFilter && eventFilter.blacklisted || []).forEach(function (event) {
        blacklisted[event] = true;
      });

      var onStorageEvent = function onStorageEvent(event) {
        var ls = (0, _storage["default"])(_storage.storageTypes.LOCAL); // In some private browsing modes, even accessing window.localStorage throws an error

        if (event.storageArea !== ls) {
          return;
        }

        if (event.key === STORAGE_KEY) {
          if (event.newValue) {
            var filteredRecords = JSON.parse(event.newValue).filter(function (event) {
              return !(event.eventName in blacklisted);
            });
            setTrackRecords(filteredRecords);
          }
        }
      };

      window.addEventListener('storage', onStorageEvent); // Load whatever is in localStorage right now as the initial popout state

      try {
        var filteredRecords = (JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || []).filter(function (event) {
          return !(event.eventName in blacklisted);
        });
        setTrackRecords(filteredRecords);
      } catch (e) {
        console.error('Error fetching initial trackRecords', e);
      }

      return function () {
        window.removeEventListener('storage', onStorageEvent);
      };
    });
  }, [mode]);
  return {
    trackRecords: trackRecords,
    setTrackRecords: setTrackRecords
  };
}